import { css } from '@emotion/css';

import { cn } from '@lyearn/style';

const dialogClasses = css`
  width: 44rem;
`;

export const DIALOG_CLASSES = {
  paper: cn('rounded-8 p-24 m-0 relative', dialogClasses),
};

export const BOTTOM_SHEET_CLASSES = {
  paperAnchorBottom: 'bg-transparent',
  content: 'pt-24 px-16',
};
